import { useQueryFetch } from '@shared/hooks/useQueryFetch';
import { ServiceProcessFieldTableColumnVM } from '@shared/types/process';
import { LngRecord, PaginatedResponse } from '@shared/types/types';
import { toLngRecord } from '@shared/util/toLngRecord';
import { normalizeColumnOptions } from './tableFieldColumnUtils';

function normalizeColumnTitle(
    title: ServiceProcessFieldTableColumnVM['title'] | string,
): LngRecord | null {
    if (title == null || title === '') {
        return null;
    }

    if (typeof title === 'string') {
        return toLngRecord(title);
    }

    return title;
}

function normalizeTableColumn(
    column: ServiceProcessFieldTableColumnVM,
): ServiceProcessFieldTableColumnVM {
    return {
        ...column,
        title: normalizeColumnTitle(column.title),
        options: normalizeColumnOptions(column.options),
    };
}

export function useTableFieldColumns(
    serviceProcessFieldId?: string,
    enabled = true,
) {
    return useQueryFetch<
        PaginatedResponse<ServiceProcessFieldTableColumnVM>,
        ServiceProcessFieldTableColumnVM[]
    >('flow/ServiceProcessFieldTableColumns/GetAll', {
        enabled: Boolean(serviceProcessFieldId) && enabled,
        params: {
            serviceProcessFieldId,
            page: 1,
            size: 100,
        },
        select(data) {
            return [...(data?.itemList ?? [])]
                .map(normalizeTableColumn)
                .sort((left, right) => left.order - right.order);
        },
    });
}
